import React from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import QuickAccessButton from './QuickAccessButon';
import { getHotelQuickAccessItems } from '../../utils/hotelPresentationUtils';
import { useZitoneoHotelPresentation } from '../../contexts/ZitoneoContentContext';

const PLACEHOLDER_ITEMS = [0, 1, 2, 3, 4];

const QuickAccessSection = () => {
    const translate = useTranslate();
    const history = useHistory();
    const { hotel, isLoading } = useZitoneoHotelPresentation();

    const quickAccess = useMemo(
        () =>
            hotel.id
                ? getHotelQuickAccessItems(hotel.id, hotel.idFirstRoom)
                : [],
        [hotel.id, hotel.idFirstRoom]
    );

    return (
        <div className='hotel-presentation__section' id='hotel-quick-access'>
            {isLoading ? (
                <LoadingPlaceholder
                    variant='text'
                    width={150}
                    height={24}
                    aria-hidden='true'
                />
            ) : (
                <h2 className='hotel-presentation__section-title'>
                    {translate('quick_access')}
                </h2>
            )}

            <ul
                className='hotel-presentation__quick-access-list'
                aria-busy={isLoading}
            >
                {isLoading
                    ? PLACEHOLDER_ITEMS.map(itemIndex => (
                          <li key={itemIndex} aria-hidden='true'>
                              <div className='quick-access-button --placeholder'>
                                  <div className='quick-access-button__icon'>
                                      <LoadingPlaceholder
                                          variant='rectangular'
                                          width={24}
                                          height={24}
                                      />
                                  </div>
                                  <LoadingPlaceholder
                                      variant='text'
                                      width='75%'
                                      height={24}
                                  />
                              </div>
                          </li>
                      ))
                    : quickAccess.map(({ label, icon, color, route }) => (
                          <li key={label}>
                              <QuickAccessButton
                                  label={label}
                                  icon={icon}
                                  color={color}
                                  onClick={() => {
                                      history.push(route);
                                  }}
                              />
                          </li>
                      ))}
            </ul>
        </div>
    );
};

export default QuickAccessSection;
